import { useState } from 'react'
import { MapPin } from 'lucide-react'
import { Button, ButtonVariant } from '@meiuca/ui-components'
import { SuggestArenaModal } from './SuggestArenaModal'
import { useToast } from '../hooks/useToast'

interface SuggestArenaEmptyStateProps {
  title?: string
  description?: string
}

/**
 * Empty state shown when there are no arenas to display — invites the user to
 * suggest one. Opens the SuggestArenaModal in place (overlay) instead of
 * navigating to a full page. Replaces the old SDUI "no-nearby-arenas" banner.
 */
export function SuggestArenaEmptyState({
  title = 'Não encontramos arenas por aqui',
  description = 'Conhece alguma quadra ou arena na sua região? Indique para nós e ajude outros atletas a encontrarem onde jogar.',
}: SuggestArenaEmptyStateProps) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { showToast } = useToast()

  const handleSuccess = (message: string) => {
    showToast({ type: 'success', message, duration: 5000 })
    setIsModalOpen(false)
  }

  const handleError = (message: string) => {
    showToast({ type: 'error', message, duration: 5000 })
  }

  return (
    <div className="max-w-md mx-auto text-center py-12 px-4">
      <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-brand-primary/10 flex items-center justify-center">
        <MapPin className="w-8 h-8 text-brand-primary" />
      </div>
      <h3 className="text-lg font-semibold text-text-primary mb-2">{title}</h3>
      <p className="text-text-secondary mb-6">{description}</p>
      <Button variant={ButtonVariant.PRIMARY} onClick={() => setIsModalOpen(true)}>
        Indicar uma arena
      </Button>

      <SuggestArenaModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSuccess={handleSuccess}
        onError={handleError}
      />
    </div>
  )
}
